<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-arrow-left-right-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Mouvement des articles</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between " style="display: block">



                            <div class="grid grid-cols-12  gap-x-6">


                                <div class=" xl:col-span-12  col-span-12 mt-4 mb-4">
                                    <input v-model="searchword" class="form-control form-control-lg w-full custom-placeholder" type="text"
                                           placeholder="Rechercher"
                                           aria-label=".form-control-lg example">
                                </div>

                                <div class=" xl:col-span-6  col-span-12 mt-4 mb-4">

                                    <div class="grid grid-cols-12  gap-x-6">
                                        <div class="xl:col-span-11  col-span-11" >
                                            <!--label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">ARTICLE</label-->

                                            <input placeholder="Veuillez sélectionner un article"  v-if="article===null" type="text" class="form-control" disabled>
                                            <input v-else :value="article.libelle" type="text" class="form-control" disabled>
                                        </div>
                                        <div class="xl:col-span-1  col-span-1">
                                            <!--label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">&nbsp;</label-->

                                            <button v-if="!disabled" @click="btnmodallistedesarticles('vente')"   class="ti-btn ti-btn-success-full ti-btn-lg ti-btn-wave">...</button>
                                            <button v-else disabled  class="ti-btn ti-btn-success-full ti-btn-lg ti-btn-wave">...</button>


                                        </div>

                                    </div>
                                </div>

                                <div class="xl:col-span-6  col-span-12 mt-4 mb-4">
                                    <select @change="load" v-model="searchmagasin" style=" display: inline-block; margin: 0 5px; padding: 2px 25px;
                                            border: 1px solid #aaa; border-radius: 3px;"
                                            class="tabulator-page-size w-full"
                                            title="Tous les magasins / entrepôt">
                                        <option value="">Tous les magasins / entrepôt</option>
                                       <option :value="liste.pid" v-for="(liste,index) in listedesmagasins" :key="index">{{liste.name}}</option>

                                    </select>
                                </div>



                                <div class="xl:col-span-6  col-span-12 mt-4 mb-4">
                                    <input class="form-control w-full" type="date" v-model="datedebut" placeholder="Date début">
                                </div>
                                <div class="xl:col-span-6  col-span-12 mt-4 mb-4">
                                    <input class="form-control w-full" type="date" v-model="datefin" placeholder="Date fin">
                                </div>



                            </div>


                            <div class="w-full flex grid-cols-2">

                                <div class="box-title mb-2 sm:mb-0"></div>

                                <div class="inline-flex rounded-md shadow-sm" role="group" aria-label="Basic example">

                                    <div class="grid lg:grid-cols-4 gap-6">

                                        <div class=" space-y-2">

                                            <select v-model="DefaultperPage" style=" display: inline-block; margin: 0 5px; border: 1px solid #aaa; border-radius: 3px;" class="tabulator-page-size form-control w-full" aria-label="Page Size" title="Affichage">
                                                <option value="500">500</option>
                                                <option value="700">700</option>
                                                <option value="1000">1000</option>
                                                <option value="1500">1500</option>
                                                <option value="3000">3000</option>
                                                <option value="4000">4000</option>

                                            </select>
                                        </div>

                                        <div class="space-y-2">

                                            <div class="space-y-2">
                                                <!--label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Impression en</label-->
                                                <select  v-model="taillemodel" class="form-control mb-3 w-full">
                                                    <option value="A4">Portait</option>
                                                    <option value="A4landscape">Paysage</option>
                                                    <!--option value="A5">A5</option>
                                                    <option value="A5landscape">A5 landscape</option-->
                                                </select>


                                            </div>
                                        </div>
                                        <div class="space-y-2">

                                            <button @click="ExportExcel('xlsx','ETAT DE MOUVEMENT DES ARTICLES')" class="ti-btn ti-btn-success-full w-full"><i class="ri-file-excel-fill"></i> Exporter en excel</button>

                                        </div>

                                        <div class="space-y-2">
                                            <button @click="print4" class="ti-btn ti-btn-primary-full w-full"><i class="ri-printer-fill"></i> Aperçu avant impression</button>

                                        </div>





                                    </div>


                                </div>
                            </div>






                        </div>


                                    <div class="box-body !p-0 mybodyheight500px">
                                        <div class="table-responsive">
                                <div class="flex flex-col h-screen">
                                    <div class="flex-grow overflow-auto">

                                        <table ref="exportable_tableetatmvtarticle" class="relative w-full border table table-bordered mytable table-hover whitespace-nowrap min-w-full">
                                            <thead>
                                            <tr>
                                                <th scope="col" class="th text-start">MAGASIN/DEPÔT/ENTREPÔT</th>
                                                <th scope="col" class="th text-start">DATE</th>
                                                <th scope="col" class="th text-start">N°DOC</th>
                                                <th scope="col" class="th text-start">FOURNISSEUR / CLIENT</th>
                                                <th scope="col" class="th text-start">SAISIR PAR</th>
                                                <th scope="col" class="th text-start">ARTICLE</th>
                                                <th scope="col" class="th text-start">STOCK INIT</th>
                                                <th scope="col" class="th text-start">ANCIENNE QTE</th>
                                                <th scope="col" class="th text-start">QTE ENTREE</th>
                                                <th scope="col" class="th text-start">QTE SORTIE</th>
                                                <th scope="col" class="th text-start">STOCK FINAL</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            <template v-if="filterdatatable.length">

                                                <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light" v-for="(datavalue,index) in filterdatatable" :key="index">

                                                   <td  data-label="MAGASIN/DEPÔT/ENTREPÔT  : "   >{{ datavalue.nommaga }}</td>
                                                   <td  data-label="DATE  : "   >{{ datavalue.docdate }}</td>
                                                   <td  data-label="N°DOC  : "   >{{ datavalue.docref }}</td>
                                                   <td  data-label="FOURNISSEUR / CLIENT  : "   >{{ datavalue.societefrsclt }}</td>
                                                   <td  data-label="SAISIR PAR  : "   >{{ datavalue.saisiepar }}</td>
                                                   <td  data-label="ARTICLE  : "   >{{ datavalue.libelle }}</td>
                                                   <td class="text-center" style="text-align: center"  data-label="STOCK INIT : "   >{{ datavalue.stck_init }}</td>
                                                   <td class="text-center" style="text-align: center"  data-label="ANCIENNE QTE : "   >{{ datavalue.stockold }}</td>
                                                   <td class="text-center" style="text-align: center"  data-label="QTE ENTREE : "   >{{ datavalue.qte_entre }}</td>
                                                   <td class="text-center" style="text-align: center"  data-label="QTE SORTIE : "   >{{ datavalue.qte_sorti }}</td>
                                                   <td class="text-center" style="text-align: center"  data-label="STOCK FINAL : "   >{{ datavalue.sctk_final }}</td>

                                                </tr>



                                            </template>


                                            <template v-else>
                                                <tr >
                                                    <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                                </tr>

                                            </template>



                                            </tbody>
                                        </table>


                                    </div>
                                </div>

                                    </div>
                                </div>



                        <div class="flex flex-col box-footer border-t-0 ">
                            <div class="flex items-center flex-wrap overflow-auto">
                                <div class="mb-2 sm:mb-0">

                                </div>
                                <div class="ms-auto">


                                    <nav aria-label="Page navigation">
                                        <ul class="ti-pagination mb-0">
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page <= 1 }" class="page-link px-3 py-[0.375rem]" @click="page--">Previous</button>
                                            </li>
                                            <li class="page-item">
                                                <button class="page-link px-3 py-[0.375rem]" :class="{ 'active': pageNumber === page }"
                                                        :key="key" v-for="(pageNumber, key) in displayedPages" @click="page = pageNumber">
                                                    {{ pageNumber }}
                                                </button>
                                            </li>
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page >= pages.length }" class="page-link px-3 py-[0.375rem]" @click="page++">Next</button>
                                            </li>
                                        </ul>
                                    </nav>





                                </div>
                            </div>
                        </div>
                    </div>






                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="print4" type="button" class="ti-btn ti-btn-primary-full"><i class="ri-printer-line align-middle"></i> Aperçu avant impression</button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>

    <div class="row" v-show="false">

        <div id="invoice">
            <page id="printOrder-data2" ref="printorderdataetatmvtarticle" class="my-5 page printOrder-data " :size="taillemodel">


                <div   class="my-5 page printOrder-data pagebreak"  >



                    <div class="p-5">

                        <section class="top-content mb-5 bb d-flex justify-content-between">
                            <div class="logo">
                                <img v-if="$store.state.etatlogo" :src="$store.state.etatlogo" alt="" class="img-fluid">
                            </div>
                            <div class="top-left">
                                <div class="logo">
                                    <!--qrcode :value="" :size="size" :level="level"></qrcode-->

                                </div>
                            </div>
                        </section>

                        <section class="mt-5">
                            <div class="row">

                                <div class="col-6">
                                    <table class="table table-bordered">
                                        <tbody >

                                        <tr>
                                            <td >Raison Social : {{$store.state.etatraisonsocial}}</td>
                                        </tr>
                                        <tr>
                                            <td >Ifu : {{$store.state.etatifu}} /  RC N° RCCM: {{$store.state.etatrccm}} </td>
                                        </tr>
                                        <tr>
                                            <td >Téléphone : {{$store.state.etattelephone}} / {{$store.state.etatadresse}}</td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-6 ">


                                    <table class="table table-bordered w-full">
                                        <tbody >
                                        <tr>
                                            <td style="text-align: center" colspan="5" >ETAT DE MOUVEMENT DES ARTICLES</td>

                                        </tr>

                                        <tr >
                                            <td colspan="5" style="text-align: center">Imprimer par :{{$store.state.appusername}} / Imprimer le {{$store.state.appserverdate}}</td>
                                        </tr>



                                        </tbody>
                                    </table>


                                </div>

                            </div>






                        </section>


                        <!--div style="width: 100%;height: auto;margin-top: 10px;margin-bottom: 10px;">

                            <h4 style="font-weight: bold; color: black; font-size: 14px;">Observation : </h4>
                            <p style="color: black; font-size: 14px;">{{tabvalue.observations}}</p>

                        </div-->

                        <section   class="product-area mt-3">

                            <table ref="exportable_tableetatmvtarticle" class="relative w-full border table table-bordered mytable table-hover whitespace-nowrap min-w-full">
                                <thead>
                                <tr>
                                    <!--th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">N°</th-->
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">MAGASIN</th>
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">DATE</th>
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">N°DOC</th>
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">FOURNISSEUR / CLIENT</th>
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">SAISIR PAR</th>
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">ARTICLE</th>
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">STOCK INIT</th>
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">ANCIENNE QTE</th>
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">QTE ENTREE</th>
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">QTE SORTIE</th>
                                    <th scope="col" class="sticky top-0 px-6 py-3 text-red-900 bg-red-300 text-start">STOCK FINAL</th>

                                </tr>
                                </thead>
                                <tbody>

                                <template v-if="filterdatatable.length">

                                    <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light" v-for="(datavalue,index) in filterdatatable" :key="index">

                                        <td  data-label="MAGASIN/DEPÔT/ENTREPÔT  : "   >{{ datavalue.nommaga }}</td>
                                        <td  data-label="DATE  : "   >{{ datavalue.docdate }}</td>
                                        <td  data-label="N°DOC  : "   >{{ datavalue.docref }}</td>
                                        <td  data-label="FOURNISSEUR / CLIENT  : "   >{{ datavalue.societefrsclt }}</td>
                                        <td  data-label="SAISIR PAR  : "   >{{ datavalue.saisiepar }}</td>
                                        <td  data-label="ARTICLE  : "   >{{ datavalue.libelle }}</td>
                                        <td class="text-center" style="text-align: center"  data-label="STOCK INIT : "   >{{ datavalue.stck_init }}</td>
                                        <td class="text-center" style="text-align: center"  data-label="ANCIENNE QTE : "   >{{ datavalue.stockold }}</td>
                                        <td class="text-center" style="text-align: center"  data-label="QTE ENTREE : "   >{{ datavalue.qte_entre }}</td>
                                        <td class="text-center" style="text-align: center"  data-label="QTE SORTIE : "   >{{ datavalue.qte_sorti }}</td>
                                        <td class="text-center" style="text-align: center"  data-label="STOCK FINAL : "   >{{ datavalue.sctk_final }}</td>

                                    </tr>



                                </template>


                                <template v-else>
                                    <tr >
                                        <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                    </tr>

                                </template>



                                </tbody>
                            </table>


                        </section>

                        <section class="balance-info">
                            <div class="row">

                            </div>
                        </section>
                        <section class="balance-info mt-3">
                            <div class="row">

                            </div>
                        </section>



                    </div>





                </div>


            </page>

        </div>

    </div>

    <modallistedesarticles @elementSelectionnearticle="handleElementSelectedarticle" ref="modallistedesarticles"></modallistedesarticles>


</template>

<script>


    import modallistedesarticles from "@/components/views/pages/stock/mvtstock/modal_listedesarticles";

    const axios =require('axios');


    import {currentDateTime, randomString, ExportExcel, impression, isValidDateString, cloneobjet} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import {mapGetters} from "vuex";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {

            searchword: function(newvalue,oldvalue){

                this.page=1

            },

            searchmagasin: function(newvalue,oldvalue){

                this.page=1

            },

            searchtypearticle: function(newvalue,oldvalue){

                this.page=1

            },

            searchcatalogue: function(newvalue,oldvalue){

                this.page=1

            },

            searchparam: function(newvalue,oldvalue){

                this.page=1

            },




        },


        computed:{
            ...mapGetters(['listedesarticles']),
            affichertout(){

                return this.datatable.length

            },

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;
                this.perPage=this.DefaultperPage;


                if (this.searchword!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {
                        return  post.libelle.toLowerCase().includes(t.searchword.toLowerCase())
                    })

                }

                if (isValidDateString(this.datedebut) && isValidDateString(this.datefin)){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        if (post.docdate!==""){
                            // if (t.mvtdatedebut<=post.docdate && post.docdate <=t.mvtdatefin){
                            if (t.datedebut<=post.docdate && post.docdate <=t.datefin){

                                return post
                            }
                        }

                    })


                }




              //  return mvalue ;
                return this.paginate(mvalue) ;
            },
        },
        components: {
            modallistedesarticles

        },

        data() {
            return {
                taillemodel:'A4landscape',
                isdisplay:false,
                titlemodal:"",
                searchtrierletableau:"",
                datatable:[],
                datatableexcel:[],
                dataetatgroupe:[],
                otherdata:[],
                listedupersonnel:[],
                datatiers:[],
                datedebut:"",
                datefin:"",
                typetableau:1,

                listedesmagasins:[],
                listedescatalogues:[],
                listedesparam:[],

                searchword:'',
                searchmagasin:'',
                searchtypearticle:'',
                searchcatalogue:'',
                searchparam:'',
                article:null,






                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 500,
                Defaultpage: 1,
                DefaultperPage: 500,
                pages: [],
            };
        },
        methods: {


            btnmodallistedesarticles(option){

                let listedatable=[],
                    titlemodal="Liste des articles",
                    typedoc="";

               let $listedatatableproduit= cloneobjet(this.listedesarticles)

                this.$refs.modallistedesarticles.show(titlemodal,option,$listedatatableproduit);

            },

            handleElementSelectedarticle(elementSelectionne) {

                /* if (elementSelectionne.typ==="add"){
                     this.jsonarticles.push(elementSelectionne.value)
                     this.newsjsonarticles.push(elementSelectionne.value)
                 }*/

                this.article=elementSelectionne.value

                this.load();


            },





            ExportExcel(type,name, fn, dl) {
                name=name+"_"+currentDateTime()
                var elt = this.$refs.exportable_tableetatmvtarticle;
                ExportExcel(type,name, fn, dl,elt);

            },



            async print4 () {


                let t=this
                let $style=[];

                let options = {  name: '_blank', }


                if (this.taillemodel==="A4landscape" ){

                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/stylelandscape1.css',
                        process.env.VUE_APP_URL+'print/stylelandscape.css'
                    ]

                }

                if (this.taillemodel==="A4" ){



                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/styleportrait.css',
                        process.env.VUE_APP_URL+'print/styleportraisizebulletin.css'
                    ]

                }

                /* this.$htmlToPaper('printOrder-data2', options, () => {
                     console.log('Printing completed or was cancelled!');
                 });
                 */




                setTimeout(() => {
                    const printContent = this.$refs.printorderdataetatmvtarticle.innerHTML;
                    impression(printContent,$style,window.document.title,[],{ format: this.taillemodel })

                }, 500);

            },




            currentDateTime(){
                return currentDateTime
            },


            async load(){

                if (this.searchmagasin==="" || this.article===null){return;}

                this.isdisplay=true;

                this.$store.dispatch('lancerchargement',true)


                const t = this;
                //let url=process.env.VUE_APP_API_URL+'/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/rapport/mvtarticle/'+this.searchmagasin+'/'+this.$store.state.appsociete+'/'+randomString();
                let url=process.env.VUE_APP_API_URL+'/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/rapport/mvtarticle/'+this.searchmagasin+'/fselect/'+this.article.pid+'/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)

                        //console.log("res.data ",res.data)
                        if(res.data.success){


                            t.datatable=[];
                            t.datatableexcel=[];
                            t.datatable=res.data.mdata.datassuivie;
                            t.datatableexcel=res.data.mdata.articlelignesexcel;


                            t.isdisplay=true;

                        }
                        else{
                            t.datatable=[];

                        }


                    })
                    .catch((error)=>{
                        //console.log("res.error ",error)
                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },


            async loadotherdata(){


                const t = this;
                let url=process.env.VUE_APP_API_URL+'/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/rapport/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){


                            t.listedesmagasins=[];
                            t.listedescatalogues=[];
                            t.listedesparam=[];

                            t.listedesmagasins=res.data.otherdata.magasin;
                            t.listedescatalogues=res.data.otherdata.catalogue;
                            t.listedesparam=res.data.otherdata.paramcom;
                            t.isdisplay=true;

                        }
                        else{
                            t.listedesmagasins=[];
                            t.listedescatalogues=[];
                            t.listedesparam=[];

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },


            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            show(titlemodal){


                this.messagesucces="";
                this.messageerror="";
                this.titlemodal=titlemodal

                this.datatable=[];

                this.datedebut=this.$store.state.appserverdate
                this.datefin=this.$store.state.appserverdate



                this.loadotherdata()
                this.load()



            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .table td {
        cursor: pointer;
    }

    .h-screen{
        height: 500px!important;
    }

    .mybodyheight500px{
        height: 500px;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xxl { max-width:100%; }

        .h-screen,.mybodyheight500px{
            height: 100%!important;
        }


    }

</style>